import * as Yup from 'yup';
import {
  yupNpnValidator,
  yupPhoneValidator,
  yupZipValidator,
} from 'Admin/utils/formValidators';

const customNpnValidator = () =>
  yupNpnValidator().test({
    name: 'server npn error',
    test: function () {
      const serverError =
        this.parent.serverValidationErrors.nationalProducerNumber;

      return serverError
        ? this.createError({
            message: serverError[0],
            path: 'nationalProducerNumber',
          })
        : true;
    },
  });

export const createUserSchema = Yup.object().shape({
  firstName: Yup.string().required('Required'),
  lastName: Yup.string().required('Required'),
  suffix: Yup.string(),
  email: Yup.string()
    .email('Invalid Email')
    .required('Required')
    .test({
      name: 'server email error',
      test: function () {
        const error = this.parent.serverValidationErrors.email;
        return error
          ? this.createError({
              message: error[0],
              path: 'email',
            })
          : true;
      },
    }),
  phoneNumber: yupPhoneValidator(),
  nationalProducerNumber: Yup.string().when('roles', {
    is: (val) => val.includes('agent'),
    then: customNpnValidator().required('NPN Required for Agent role'),
    otherwise: customNpnValidator(),
  }),
  address: Yup.object().shape({
    zipCode: yupZipValidator(),
    city: Yup.string(),
    state: Yup.string(),
    lineOne: Yup.string(),
    lineTwo: Yup.string(),
  }),
  roles: Yup.array()
    .of(Yup.string())
    .min(1, 'At least one role must be selected.'),
});
